import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  hasNextRankById,
  nextRankDescriptionById,
  nextRankProgressById,
  rankIdById,
} from '/redux/selector/coach.selector';

import Summary from './Summary';

export default connect(
  createStructuredSelector({
    rankId: rankIdById,
    rankName: nextRankDescriptionById,
    percent: nextRankProgressById,
    hasNextRank: hasNextRankById,
  }),
)(Summary);
